import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';

import { checkForError } from 'app/dealer/utils';
import { ConnectedSideBarWrapper } from 'app/shared/modules/overlay/defaultOverlays/sidebar/SideBarWrapper/SideBarWrapper';
import { openOverlay } from 'app/shared/modules/overlay/actions';
import { refreshToken } from 'app/dealer/login/actions';
import * as Config from 'app/config';

const sendApiCall = (url, options, useBackendApi, isCommon) => {
  return (dispatch, getState) => {
    const state = getState();
    const {
      dealerLogin: { userLoggedIn, accessToken },
    } = state;
    const defaultOptions = {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Tracking-Guid': state?.tracking?.guid,
        'Accept-Language': 'de',
        'X-Heycar-Tenant': 'de',
        ...(userLoggedIn && { Authorization: `Bearer ${accessToken}` }),
      },
      mode: 'cors',
      ...options,
    };
    if (options.isFileUpload) {
      delete defaultOptions.headers['Content-Type'];
    }
    let apiUrl;
    if (!useBackendApi) {
      apiUrl = url;
    } else {
      apiUrl = isCommon
        ? `${Config.COMMON_URL}${url}`
        : `${Config.API_URL}${url}`;
    }
    return fetch(apiUrl, defaultOptions)
      .then(response => checkForError(response, userLoggedIn))
      .then(response => response.text())
      .then(response => {
        return response ? JSON.parse(response) : {};
      })
      .catch(error => Promise.reject(error));
  };
};

export const apiCall = (
  url,
  options = {},
  useBackendApi = true,
  isCommon = false,
) => {
  return (dispatch, getState) => {
    const state = getState();

    if (state?.dealerLogin?.userLoggedIn) {
      return dispatch(refreshToken()).then(() => {
        return dispatch(sendApiCall(url, options, useBackendApi, isCommon));
      });
    }

    return dispatch(sendApiCall(url, options, useBackendApi, isCommon));
  };
};

/**
 * see https://github.com/hey-car/web-app/pull/2253 for thunk/saga usage
 * @param {string} url
 * @param {Object} options
 * @param {boolean} useBackendApi
 * @returns {(dispatch: any) => {promise: Promise<any>, abortController: AbortController|null}}
 */
export const abortableClientApiCall = (
  url,
  options = {},
  useBackendApi = true,
) => {
  let abortController = null;
  let optionsWithSignal = options;
  if ('AbortController' in window) {
    abortController = new AbortController();
    optionsWithSignal = {
      ...optionsWithSignal,
      signal: abortController.signal,
    };
  }
  return dispatch => {
    const promise = dispatch(apiCall(url, optionsWithSignal, useBackendApi));
    return { promise, abortController };
  };
};

export const openNavMenuClick = ({ target, title, component }) => {
  return dispatch => {
    if (target === 'auth') {
      dispatch(
        openOverlay(ConnectedSideBarWrapper, {
          props: {
            title,
            target,
            component,
          },
        }),
      );
    }
  };
};
